import React from "react";
import { FaCaretRight } from "react-icons/fa6";
import { FaReact } from "react-icons/fa";
import { TbSql } from "react-icons/tb";
import { BiLogoTailwindCss } from "react-icons/bi";
import { VscAzure } from "react-icons/vsc";
import { FaNode } from "react-icons/fa";
import { useNavigate } from "react-router";
import { SiSocketdotio } from "react-icons/si";

function TriviaNight() {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col p-3">
            <div
                onClick={() => {
                    navigate("/");
                }}
                className="flex items-center opacity-60 text-sm transition-all hover:cursor-pointer hover:opacity-100 font-sourcecodepro"
            >
                &larr; back
            </div>
            <div className="text-3xl font-bold">Trivia Night: Multiplayer</div>
            <div className="flex flex-col gap-8">
                <div className="text-xl font-light italic">
                    A multiplayer trivia game that utilizes React, Tailwind,
                    Socket.IO and Node.js
                </div>
                <div className="mx-auto w-4/5 md:w-full">
                    <img className="border-4" src="/Images/triviagif.gif"></img>
                    <div className="italic font-extralight text-center">
                        TriviaNight
                    </div>
                </div>
            </div>

            <div className="text-2xl">Goal For Project</div>
            <div>
                The goal for this project was initially to practice api
                integration with React and work with react hooks to manage
                state. However once i achieved basic functionality i wanted to
                try out multiplayer integration with socket.io.
            </div>
            <div className="mx-auto w-4/5 md:w-full">
                <img className="border-4" src="/Images/socketio.jpg"></img>
                <div className="italic font-extralight text-center">
                    Socket.IO
                </div>
            </div>
            <div className="text-2xl">Technology</div>
            <div className="flex flex-col gap-8">
                <div>
                    This project required me to use a certain technology stack
                    which includes:
                </div>
                <div className="flex flex-row text-3xl lg:text-8xl mx-auto justify-around w-full">
                    <div className="flex flex-col items-center">
                        <BiLogoTailwindCss />
                        <div className="text-xl text-center">Tailwind</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <FaReact />
                        <div className="text-xl text-center">React</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <FaNode />

                        <div className="text-xl text-center">Node JS</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <SiSocketdotio />

                        <div className="text-xl text-center">Socket IO</div>
                    </div>
                </div>

                <div>
                    These technologies allowed me to create a fun dynamic
                    experience for multiple players using socket io.
                </div>
            </div>
            <div className="text-2xl mt-4">Code Structure</div>
            <div className="flex flex-col gap-8">
                <div className="mx-auto w-4/5 md:w-full">
                    <img
                        className="border-4 mx-auto"
                        src="/Images/triviaprojectlayout.png"
                    ></img>
                    <div className="italic font-extralight text-center">
                        Project Layout
                    </div>
                </div>
                <div>
                    For this project i kept the components and functionality of
                    each part of the web app seperate. For example the API that
                    interfaced with my backend web server was in the services
                    folder and components were in another folder, and different
                    render screens were in another. This kept code clean and
                    resusable.
                </div>
            </div>
            <div className="text-2xl mt-4">Server</div>
            <div className="flex flex-col gap-8">
                <div className="mx-auto w-4/5 md:w-full">
                    <img
                        className="border-4 mx-auto"
                        src="/Images/socketiodiagram.png"
                    ></img>
                    <div className="italic font-extralight text-center">
                        Project Layout
                    </div>
                </div>
                <div>
                    The server in this case was for clients to connect to socket
                    io. What socket io does is create a permenent web socket
                    between user and server that that sends message/events back
                    and forth to one another. This saves opening and closing
                    sockets on every request. Socket io works by having each
                    player be in a unique room. Other players can then add
                    themselves to other rooms, enabling messages to be just
                    dispatched to players in those rooms. This is helpful for
                    managing different game states or chat rooms where you dont
                    want messages sent to everyone connected to the server.
                </div>
            </div>

            <div className="text-2xl mt-4">Post-Mortem</div>
            <div className="flex flex-col gap-2">
                <div className="font-bold">What I learned</div>
                <div>
                    This project reinforced my understanding of asyncronous
                    fetching of API data and syncing states across a network and
                    how rooms and messages are sent and emitted across a
                    networked application. I am looking to extend my knowledge
                    and understanding of web sockets and socket io by building
                    more complex projects in the future, such as a 2d
                    multiplayer game with user interaction/chat messages,
                    perhaps even voice chat with integration from a library
                    called WebRTC (Real time communication).
                </div>
                <div className="mx-auto w-4/5 md:w-full">
                    <img
                        className="border-4 mx-auto"
                        src="/Images/webrtc.jpg"
                    ></img>
                    <div className="italic font-extralight text-center">
                        WebRTC
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TriviaNight;
